import React from 'react';
import { useMediaQuery } from 'react-responsive';
import SupportContent from './SupportContent';

const Mobile = ({ children }) => {
  const isMobile = useMediaQuery({ maxWidth: 767 });
  return isMobile ? children : null;
};

const MobileResponsive = props => (
  <Mobile>
    <SupportContent {...props} />
  </Mobile>
);

export default MobileResponsive;
